import leveraged_synth_stocks_icon from './files/leveraged_synth_stocks_icon.svg'
import check_icon_2 from './files/check_icon_2.svg'
import yolocoaster_pepecoaster from './files/yolocoaster_pepecoaster.png'
import yolocoaster_logo_banner from './files/yolocoaster_logo_banner.png'
import yolocoaster_banner_bg from './files/yolocoaster_banner_bg.jpg'
import slide_2_bg from './files/slide_2_bg.jpg'

import yolo_token_banner_bg from './files/token/yolo_token_banner_bg.jpg'
import yolo_token_logo_hor from './files/token/yolo_token_logo_hor.svg'

import friend_tech_banner_bg from './files/friend/friend_tech_banner_bg.jpg'
import friend_tech_image from './files/friend/friend_tech_image.png'
import friend_tech_logo from './files/friend/friend_tech_logo.png'

export const carrouselAssets = {
  leveraged_synth_stocks_icon,
  check_icon_2,
  yolocoaster_pepecoaster,
  yolocoaster_logo_banner,
  yolocoaster_banner_bg,
  slide_2_bg,
  yolo_token_banner_bg,
  yolo_token_logo_hor,
  friend_tech_banner_bg,
friend_tech_image,
friend_tech_logo,
}
